`use strict`;

import Utils from '../libs/utils';

class PartnersLocations {
    constructor() {
        this.utils = new Utils();
        
        window.selectors = {};
        window.selectors.selectCountry = `.js-select-country`;
        window.selectors.selectRegion = `.js-select-region`;
        window.selectors.selectCity = `.js-select-city`;
        this.init();
    }

    init() {
        $('.js-select2').select2();

        $(window.selectors.selectCountry).on('change', (e) => {
            let selectEl = $(e.target);
            let selector = selectEl.closest('.form-group').next().find(window.selectors.selectRegion);
            let countryID = selectEl.val();
            this.utils.populateRegions(countryID, selector);
        });

        $(window.selectors.selectRegion).on('change', (e) => {
            let selectEl = $(e.target);
            let selector = selectEl.closest('.form-group').next().find(window.selectors.selectCity);
            let regionID = selectEl.val();
            this.utils.populateCities(regionID, selector);
        });
    }
}

new PartnersLocations();
